import RAdmin from './admin.routes'
import RAudit from './audit.routes'
import RSupplyChainManager from './scm.routes'
import RLogisticsOfficer from './lo.routes'
import RWarehouseOfficer from './wo.routes'
import RRetailManager from './rm.routes'
import RPurchaserOfficer from './po.routes'
import RRetailOfficer from './ro.routes'
import RShared from './shared.routes'
import RProduction from './prd.routes'

const allRoutes = []

export default allRoutes.concat(
  RAdmin,
  RAudit,
  RShared,
  RSupplyChainManager,
  RLogisticsOfficer,
  RWarehouseOfficer,
  RRetailManager,
  RPurchaserOfficer,
  RRetailOfficer,
  RProduction
)
